import { Envelope } from "@/icons/Envelope.tsx";
import { FC } from "react";

interface EmailShareProps {
  subject?: string;
  body?: string;
  url?: string;
  onError?: () => void;
}

export const EmailShareButton: FC<EmailShareProps> = ({
  subject,
  body,
  url,
  onError,
}) => {
  const handleClick = () => {
    try {
      const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject || "")}&body=${encodeURIComponent(
        `${body || ""} ${url || ""}`,
      )}`;

      window.open(mailtoUrl, "_blank");
    } catch (error) {
      if (onError) {
        onError();
      }
    }
  };

  return (
    <button
      className="bg-slate-600 w-8 h-8 flex items-center justify-center rounded-full"
      onClick={handleClick}
    >
      <Envelope size={18} />
    </button>
  );
};
